/** W11–W13 GOT Result Update form and replications (manual p255–257, screenshot 154120). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { GotResultUpdatePage } from "@/features/got/components/result-update-pages";

const search = z.object({
  view: z.enum(["replications"]).optional(),
  kind: z.enum(["in-terra", "in-situ"]).optional(),
  step: z
    .enum([
      "sowing",
      "transplanting",
      "observation",
      "dna",
      "pcr",
      "gea",
      "abort",
    ])
    .optional(),
  repl: z.number().int().min(1).optional(),
});

export const Route = createFileRoute(
  "/_app/quality/got/result-update/$sampleId/"
)({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("got.result_update"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { sampleId } = Route.useParams();
  const s = Route.useSearch();
  return <GotResultUpdatePage sampleId={Number(sampleId)} search={s} />;
}
